<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted mb-1 mb-md-0">Copyright © <a href="https://www.armadilloamarillo.com" target="_blank">Armadillo Amarillo S.L.</a>.</p>
  <p class="text-muted">Versión {{version}}</p>
</footer>